import React, { Component } from 'react';
import moment from 'moment'
import Chart from 'chart.js'
import { SERVER_URL } from '../ServerConfig'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BeatLoader } from 'react-spinners'
import MultiSelect from "react-multi-select-component";

var newChart = null;
export default class InverterCombinerBoxesDetails extends Component {
    

    constructor(props) {
        super(props);
        const selected = [];

        this.state = {
            date: new Date(),
            isReady: false,
            selected : [
                { label: "String 1", value: "string1" },
                { label: "String 2", value: "string2" },
                { label: "String 3", value: "string3"},
                { label: "String 4", value: "string4" },
                { label: "String 5", value: "string5" },
                { label: "String 6", value: "string6" },
                { label: "String 7", value: "string7" },
                { label: "String 8", value: "string8" },
                { label: "String 9", value: "string9" },
                { label: "String 10", value: "string10" },
                { label: "String 11", value: "string11" },
                { label: "String 12", value: "string12" },
                { label: "String 13", value: "string13" },
                { label: "String 14", value: "string14" },
                { label: "String 15", value: "string15" },
                { label: "String 16", value: "string16" },
                { label: "String 17", value: "string17" },
                { label: "String 18", value: "string18" },
                { label: "String 19", value: "string19" },
                { label: "String 20", value: "string20" },
                { label: "String 21", value: "string21" },
                { label: "String 22", value: "string22" },
                { label: "String 23", value: "string23" },
                { label: "String 24", value: "string24" },
              ],
            options : [
                { label: "String 1", value: "string1" },
                { label: "String 2", value: "string2" },
                { label: "String 3", value: "string3"},
                { label: "String 4", value: "string4" },
                { label: "String 5", value: "string5" },
                { label: "String 6", value: "string6" },
                { label: "String 7", value: "string7" },
                { label: "String 8", value: "string8" },
                { label: "String 9", value: "string9" },
                { label: "String 10", value: "string10" },
                { label: "String 11", value: "string11" },
                { label: "String 12", value: "string12" },
                { label: "String 13", value: "string13" },
                { label: "String 14", value: "string14" },
                { label: "String 15", value: "string15" },
                { label: "String 16", value: "string16" },
                { label: "String 17", value: "string17" },
                { label: "String 18", value: "string18" },
                { label: "String 19", value: "string19" },
                { label: "String 20", value: "string20" },
                { label: "String 21", value: "string21" },
                { label: "String 22", value: "string22" },
                { label: "String 23", value: "string23" },
                { label: "String 24", value: "string24" },
              ],
            drawData : {
                keys : [],
                data : []
            },
            data : {
                'string1' : true,
                'string2' : true,
                'string3' : true,
                'string4' : true,
                'string5' : true,
                'string6' : true,
                'string7' : true,
                'string8' : true,
                'string9' : true,
                'string10' : true,
                'string11' : true,
                'string12' : true,
                'string13' : true,
                'string14' : true,
                'string15' : true,
                'string16' : true,
                'string17' : true,
                'string18' : true,
                'string19' : true,
                'string20' : true,
                'string21' : true,
                'string22' : true,
                'string23' : true,
                'string24' : true,
            }
        }

        this.shouldUpdateUI = true;
        this.handlePreviousDay = this.handlePreviousDay.bind(this);
        this.handleNextDay = this.handleNextDay.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }

    componentDidMount() {
        this.fetchDaySummary(this.state.date);
    }

    componentWillUnmount() {
        this.shouldUpdateUI = false;
    }

    fetchDaySummary(date) {
        this.setState({ isReady: false, drawData : { keys : [], data : [] }});
        const token = this.props.user.payload.token;
        const inverter = this.props.inverter;

        let day = moment(date).toISOString();
        fetch(SERVER_URL + '/v1/inverters/' + inverter._id + '/getCombinerBoxesStatisticsOfDay', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token,
            },
            body: JSON.stringify({
                day: day
            })
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                    return;
                } else {
                    return response.json();
                }
            })
            .then(data => {
               
                let content = data.content;
                let keys = Object.keys(content);

                let keyData = [];
                keys.forEach(e => {
                    keyData.push(moment(e).format('HH:mm'))
                });

                let values = Object.values(content);
                this.setState({ isReady: true, drawData : { keys : keyData, data : this.getDrawStringValue(keys, values)} });
                this.drawCanvas(this.state.data);
            })
    }

    formatNumber(number) {
        if (!number) {
            return 0;
        }
        return Number(number).toFixed(3);
    }

    getDrawStringValue(keys, values) {
        let string1 = [];
        let string2 = [];
        let string3 = [];
        let string4 = [];
        let string5 = [];
        let string6 = [];
        let string7 = [];
        let string8 = [];
        let string9 = [];
        let string10 = [];
        let string11 = [];
        let string12 = [];
        let string13 = [];
        let string14 = [];
        let string15 = [];
        let string16 = [];
        let string17 = [];
        let string18 = [];
        let string19 = [];
        let string20 = [];
        let string21 = [];
        let string22 = [];
        let string23 = [];
        let string24 = [];

        let current = moment();
        values.forEach((e, idx) => {
            let date = moment(keys[idx]);
            if (date.isAfter(current)) {
                return;
            }
            if (!e) {
                string1.push(0);
                string2.push(0);
                string3.push(0);
                string4.push(0);
                string5.push(0);
                string6.push(0);
                string7.push(0);
                string8.push(0);
                string9.push(0);
                string10.push(0);
                string11.push(0);
                string12.push(0);
                string13.push(0);
                string14.push(0);
                string15.push(0);
                string16.push(0);
                string17.push(0);
                string18.push(0);
                string19.push(0);
                string20.push(0);
                string21.push(0);
                string22.push(0);
                string23.push(0);
                string24.push(0);
            } else {
                string1.push(this.formatNumber(e.mC1Cur/1000));
                string2.push(this.formatNumber(e.mC2Cur/1000));
                string3.push(this.formatNumber(e.mC3Cur/1000));
                string4.push(this.formatNumber(e.mC4Cur/1000));
                string5.push(this.formatNumber(e.mC5Cur/1000));
                string6.push(this.formatNumber(e.mC6Cur/1000));
                string7.push(this.formatNumber(e.mC7Cur/1000));
                string8.push(this.formatNumber(e.mC8Cur/1000));
                string9.push(this.formatNumber(e.mC9Cur/1000));
                string10.push(this.formatNumber(e.mC10Cur/1000));
                string11.push(this.formatNumber(e.mC11Cur/1000));
                string12.push(this.formatNumber(e.mC12Cur/1000));
                string13.push(this.formatNumber(e.mC13Cur/1000));
                string14.push(this.formatNumber(e.mC14Cur/1000));
                string15.push(this.formatNumber(e.mC15Cur/1000));
                string16.push(this.formatNumber(e.mC16Cur/1000));
                string17.push(this.formatNumber(e.mC17Cur/1000));
                string18.push(this.formatNumber(e.mC18Cur/1000));
                string19.push(this.formatNumber(e.mC19Cur/1000));
                string20.push(this.formatNumber(e.mC20Cur/1000));
                string21.push(this.formatNumber(e.mC21Cur/1000));
                string22.push(this.formatNumber(e.mC22Cur/1000));
                string23.push(this.formatNumber(e.mC23Cur/1000));
                string24.push(this.formatNumber(e.mC24Cur/1000));
            }
        });

        let data = [];
        data.push({ 'key' : 'string1', 'label' : 'String 1', 'values' : string1});
        data.push({ 'key' : 'string2', 'label' : 'String 2', 'values' : string2});
        data.push({ 'key' : 'string3', 'label' : 'String 3', 'values' : string3});
        data.push({ 'key' : 'string4', 'label' : 'String 4', 'values' : string4});
        data.push({ 'key' : 'string5', 'label' : 'String 5', 'values' : string5});
        data.push({ 'key' : 'string6', 'label' : 'String 6', 'values' : string6});
        data.push({ 'key' : 'string7', 'label' : 'String 7', 'values' : string7});
        data.push({ 'key' : 'string8', 'label' : 'String 8', 'values' : string8});
        data.push({ 'key' : 'string9', 'label' : 'String 9', 'values' : string9});
        data.push({ 'key' : 'string10', 'label' : 'String 10', 'values' : string10});
        data.push({ 'key' : 'string11', 'label' : 'String 11', 'values' : string11});
        data.push({ 'key' : 'string12', 'label' : 'String 12', 'values' : string12});
        data.push({ 'key' : 'string13', 'label' : 'String 13', 'values' : string13});
        data.push({ 'key' : 'string14', 'label' : 'String 14', 'values' : string14});
        data.push({ 'key' : 'string15', 'label' : 'String 15', 'values' : string15});
        data.push({ 'key' : 'string16', 'label' : 'String 16', 'values' : string16});
        data.push({ 'key' : 'string17', 'label' : 'String 17', 'values' : string17});
        data.push({ 'key' : 'string18', 'label' : 'String 18', 'values' : string18});
        data.push({ 'key' : 'string19', 'label' : 'String 19', 'values' : string19});
        data.push({ 'key' : 'string20', 'label' : 'String 20', 'values' : string20});
        data.push({ 'key' : 'string21', 'label' : 'String 21', 'values' : string21});
        data.push({ 'key' : 'string22', 'label' : 'String 22', 'values' : string22});
        data.push({ 'key' : 'string23', 'label' : 'String 23', 'values' : string23});
        data.push({ 'key' : 'string24', 'label' : 'String 24', 'values' : string24});
        return data;
    }

    getColor(index) {
        let colours = ['#E1071C', '#D83293', '#058EAD', '#9B4731', '#80DF1F', '#01C5B3', '#5C0979', '#3278CD', '#FB60C2', '#966702',
                        '#E94D13', '#A00ED6' , '#789F9B', '#5B4E0B', '#74EC7B', '#0BB08B', '#211E6A', '#0B6CEA', '#DA3750', '#D3DC71',
                    '#F17C33', '#3CAB9F', '#8ADE36', '#C41EA0'];
        return colours[index]; 
    }

    drawCanvas(dataState) {
        if (!this.state.isReady) {
            return;
        }
        let keys = this.state.drawData.keys;
        let data = this.state.drawData.data;
        let filteredKeys = [];
        let datasets = []
        data.forEach((d, index) => {
            if (!dataState[d.key]) {
                return;
            }
            filteredKeys.push(keys[index]);
            let color = this.getColor(index);
            datasets.push({
                label: d.label,
                data: d.values,
                borderColor: color,
                backgroundColor : color,
                pointBorderColor: [
                    'rgba(255, 0, 0, 1)'
                ],
                pointBackgroundColor: [
                    'rgba(255, 0, 0, 1)'
                ],
                borderWidth: 1.5,
                pointHitRadius: 2,
                fill: false,
            })
        })
        var ctx = document.getElementById('newChart');
        if (ctx) {
            if (newChart) {
                newChart.destroy();
            }
            newChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: keys,
                    datasets: datasets
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                maxTicksLimit: 12
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 5
                            }
                        }]
                    },
                    elements: {
                        point: {
                            radius: 0
                        }
                    }
                }
            });
        }

    }


    handlePreviousDay(event) {
        let date = this.state.date;
        let previousDate = moment(date).subtract(1, 'day').toDate();

        this.setState({
            date: previousDate,
            isReady: false,
        })
        this.fetchDaySummary(previousDate);
    }

    handleNextDay(event) {
        let date = this.state.date;
        let nextDate = moment(date).add(1, 'day').toDate();
        this.setState({
            date: nextDate,
            isReady: false,
        })
        this.fetchDaySummary(nextDate);
    }

    handleDaySelect(selectedDate) {
        this.setState({
            date: selectedDate,
            isReady: false,
        })
        this.fetchDaySummary(selectedDate);
    }

    handleRefresh(event) {
        this.setState({
            isReady: false,
        })
        this.fetchDaySummary(this.state.date);
    }

    handleReset(event) {
        let currentDate = new Date();
        this.setState({
            date: currentDate,
            isReady: false,
        })
        this.fetchDaySummary(currentDate);
    }

    getCalendarContent() {
        if (!this.state.isReady) {
            return (
                <div className="main-content d-flex justify-content-center mt-5">
                    <BeatLoader size={30} color="#4A90E2" />
                </div>
            );
        }
        return (
            <canvas id="newChart" height="500"></canvas>
        )
    }

    changeRenderState(renderState) {
        this.setState({
            renderState: renderState
        });
    }

    onSelectionChange(selected) {
        let data = {
            'string1' : false,
            'string2' : false,
            'string3' : false,
            'string4' : false,
            'string5' : false,
            'string6' : false,
            'string7' : false,
            'string8' : false,
            'string9' : false,
            'string10' : false,
            'string11' : false,
            'string12' : false,
            'string13' : false,
            'string14' : false,
            'string15' : false,
            'string16' : false,
            'string17' : false,
            'string18' : false,
            'string19' : false,
            'string20' : false,
            'string21' : false,
            'string22' : false,
            'string23' : false,
            'string24' : false,
        }
        selected.forEach(s => {
            data[s.value] = true;
        });

        this.setState({
            selected: selected,
            data : data
        });

        this.drawCanvas(data);
    }

    render() {
        let overrideStrings = {
            selectSomeItems: "Select strings...",
            allItemsAreSelected: "All strings are selected",
        }
        return (
            <section className="">
                <div className="col-12">
                    <div className="col-sm-12">
                        <div className="col-xs-12 col-xl-3">
                            <MultiSelect
                                options={this.state.options}
                                value={this.state.selected}
                                onChange={this.onSelectionChange}
                                overrideStrings={overrideStrings}
                            />
                        </div>
                        <div className="d-flex justify-content-center energy-chart-header-inverter">
                            <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handlePreviousDay}>
                                <i className="fa fa-chevron-left"></i>
                            </button>
                            <DatePicker dateFormat="dd/MM/yyyy" selected={this.state.date} className="day-picker-input form-control form-control-sm"
                                onChange={date => this.handleDaySelect(date)} todayButton="Today" />
                            <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handleNextDay}>
                                <i className="fa fa-chevron-right"></i>
                            </button>
                            <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handleRefresh}>
                                <i className="fa fas fa-sync-alt"></i>
                            </button>
                            <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handleReset}>
                                <i className="fas fa-reply"></i>
                            </button>
                        </div>
                        <div className="d-flex justify-content-center mt-2">
                            {this.getCalendarContent()}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}